import PropTypes from 'prop-types';
import {formatDateShort} from '@ozgene/gp5.utils.date-functions';

function DateFormatter(props) {
  const {value} = props;

  return formatDateShort(value);
}

DateFormatter.propTypes = {
  value: PropTypes.string.isRequired,
};

export default DateFormatter;
